import React from 'react';
import { View } from 'react-native';
import { Spinner } from '../../components/spinner/Spinner';
import EmptyState from '../../components/emptyState/EmptyState';

export function withResponseHandler (WrappedComponent) {

	const ReturnedComponent = (props) => {

		const {
			error,
			loading,
			data,
			refetch,
			LoadingComponent,
			ErrorComponent,
			NoDataComponent,
			blockDataWhileLoading,
		} = props;

		if (error && !data) {
			if (ErrorComponent) {
				return <ErrorComponent error={error} refetch={refetch} />;
			}
			return (
				<EmptyState
					icon="cloud-offline-outline"
					message="Something went wrong loading this page"
					hint="Check your connection and go back to try again."
				/>
			);
		}

		if (loading && !data) {
			if (LoadingComponent) {
				return <LoadingComponent />;
			}
			else {
				return <Spinner />;
			}
		}

		if (!data) {
			if (NoDataComponent) {
				return <NoDataComponent />;
			}
			return <EmptyState message="Nothing to show here yet" hint="There are no details to show on this page." />;
		}

		// Driver-critical mobile screens opt in to blocking cached detail data behind a
		// spinner overlay while an online refresh is loading, so drivers cannot act on
		// stale data. The screen stays mounted (unlike a full-screen spinner swap), so
		// scroll position survives on-focus refreshes; the wrapper View must therefore
		// stay in the tree regardless of loading state.
		if (blockDataWhileLoading !== undefined) {
			return (
				<View style={{ flex: 1 }}>
					<WrappedComponent
						{...props}
					/>
					{Boolean(loading && blockDataWhileLoading) && <Spinner isOverlay />}
				</View>
			);
		}

		return (
			<WrappedComponent
				{...props}
			/>
		);
	};

	return ReturnedComponent;
}

